export const questions = [
    {
        id: 0,
        question: 'Ett företag har fasta kostnader på 200 000 kr och en täckningsgrad på 40 %. Vilken omsättning krävs för att nå nollpunkten (kritisk punkt)?',
        options: [
            { text: '300 000 kr', isCorrect: false },
            { text: '400 000 kr', isCorrect: false },
            { text: '500 000 kr', isCorrect: true },
            { text: '800 000 kr', isCorrect: false }
        ]
    },
    {
        id: 1,
        question: 'En boll och ett rack kostar 110 kr totalt. Racket kostar 100 kr mer än bollen. Vad kostar bollen?',
        options: [
            { text: '1 kr', isCorrect: false },
            { text: '5 kr', isCorrect: true },
            { text: '10 kr', isCorrect: false },
            { text: '15 kr', isCorrect: false }
        ]
    },
    {
        id: 2,
        question: 'Nästa nummer',
        questionText: 'Vilket tal kommer näst i serien? 2, 6, 12, 20, 30, ?',
        options: [
            { text: '38', isCorrect: false },
            { text: '40', isCorrect: false },
            { text: '42', isCorrect: true },
            { text: '44', isCorrect: false }
        ]
    },
    {
        id: 3,
        question: 'Vad kallas det när ett företag ökar sin skuldsättningsgrad för att försöka öka avkastningen på eget kapital?',
        options: [
            { text: 'Likviditetsfälla', isCorrect: false },
            { text: 'Hävstångseffekt (Leverage)', isCorrect: true },
            { text: 'Täckningsbidrag', isCorrect: false },
            { text: 'Marginaleffekt', isCorrect: false }
        ]
    },
    {
        id: 4,
        question: 'Vilket momspålägg motsvarar att dra av en marginalmoms på 20 % från ett pris inklusive moms?',
        options: [
            { text: '12 %', isCorrect: false },
            { text: '20 %', isCorrect: false },
            { text: '25 %', isCorrect: true },
            { text: '30 %', isCorrect: false }
        ]
    },
    {
        id: 5,
        question: 'Utslagsfråga – närmast vinner',
        questionText: 'Enligt SCB, hur många registrerade aktiebolag fanns det i Sverige vid ingången av år 2024?',
        isTiebreaker: true,
        placeholder: 'Ange antal',
        options: []
    }
]
